import { Auth } from '../auth';
import { hasPermissionToAccess } from './permissions';
import { getFirstRouteWithAccess } from '../routes/permissions';

async function hasPermissionToAccessBasedOnProfileGuard(to, _, next) {
  const user = await Auth.getSessionData();

  if (hasPermissionToAccess(user.profile || 'admin', to.name)) {
    next();
  } else {
    next('/not-found');
  }
}

async function hasPermissionToAccessDashboardBasedOnProfileGuard(to, _, next) {
  const user = await Auth.getSessionData();

  if (hasPermissionToAccess(user.profile || 'admin', to.name)) {
    next();
  } else {
    const firstRouteWithAccess = getFirstRouteWithAccess(user.profile);
    const nextPath = routes[0].children.find(
      r => r.name === firstRouteWithAccess,
    );

    next(nextPath || '/not-found');
  }
}

export const routes = [
  {
    path: '/',
    component: require('../../components/app.vue').default,
    children: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        meta: {
          title: 'Dashboard',
        },
        component: require('../../components/dashboard.vue').default,
        beforeEnter: hasPermissionToAccessDashboardBasedOnProfileGuard,
      },
      {
        name: 'AdminUsers',
        path: '/admin-users',
        meta: {
          title: 'Administradores',
        },
        component: require('../../components/admin-users/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'AdminUsersCreate',
        path: '/admin-users/new',
        meta: {
          title: 'Criação Usuários Admin',
        },
        component: require('../../components/admin-users/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'AdminUsersEdit',
        path: '/admin-users/edit/:id',
        meta: {
          title: 'Edição Usuários Admin',
        },
        component: require('../../components/admin-users/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Consumers',
        path: '/consumers',
        meta: {
          title: 'Consumidores',
        },
        component: require('../../components/users/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Traders',
        path: '/traders',
        meta: {
          title: 'Comercializadores',
        },
        component: require('../../components/users/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Partners',
        path: '/partners',
        meta: {
          title: 'Parceiros',
        },
        component: require('../../components/users/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Users',
        path: '/users',
        meta: {
          title: 'Usuários',
        },
        component: require('../../pages/user/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Investors',
        path: '/investors',
        meta: {
          title: 'Investidores',
        },
        component: require('../../components/users/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserProfileEditProfile',
        path: '/user/new/:profile',
        meta: {
          title: 'Edição Pefil Usuário',
        },
        component: require('../../components/users/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserProfileEditUser',
        path: '/user/edit/:id/:accountProfile',
        meta: {
          title: 'Edição Pefil Usuário',
        },
        component: require('../../components/users/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'ConsumerDataUser',
        path: '/user/view/:id/consumer',
        meta: {
          title: 'Edição Consumidor',
        },
        component: require('../../components/users/consumer.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InvoicesDataProfile',
        path: '/user/:id/invoices/:profile',
        meta: {
          title: 'Edição Faturas',
        },
        component: require('../../components/users/invoices.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InstallationAccount',
        path: 'user/:id/installations/:accountId',
        meta: {
          title: 'Instalações',
        },
        component: require('../../components/installations/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InstallationEdit',
        path: 'installation/edit/:id',
        meta: {
          title: 'Instalações',
        },
        component: require('../../components/installations/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Faqs',
        path: '/faqs',
        meta: {
          title: 'FAQS',
        },
        component: require('../../components/faq/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Installation',
        path: '/installation',
        meta: {
          title: 'Instalações',
        },
        component: require('../../pages/installation/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Panorama',
        path: '/panorama',
        meta: {
          title: 'Panorama',
        },
        component: require('../../pages/panorama/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'NewPanorama',
        path: '/new-panorama',
        meta: {
          title: 'Novo Panorama',
        },
        component: require('../../pages/new-panorama/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PanoramaCustom',
        path: '/panorama-custom',
        meta: {
          title: 'Panorama',
        },
        component: require('../../components/panorama-custom/index.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Billing',
        path: '/billing',
        meta: {
          title: 'Faturamento',
        },
        component: require('../../pages/invoice/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'OverdueInvoice',
        path: '/overdue-invoice',
        meta: {
          title: 'Faturas Atrasadas',
        },
        component: require('../../pages/overdue-invoice/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Loggers',
        path: '/loggers',
        meta: {
          title: 'Loggers',
        },
        component: require('../../components/logger/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'FaqCreate',
        path: '/faq/new',
        meta: {
          title: 'Criação FAQ',
        },
        component: require('../../components/faq/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'FaqEdit',
        path: '/faq/edit/:id',
        meta: {
          title: 'Edição FAQ',
        },
        component: require('../../components/faq/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },

      {
        name: 'Coupons',
        path: '/coupons',
        meta: {
          title: 'Coupons',
        },
        component: require('../../components/coupon/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CouponCreate',
        path: '/coupon/new',
        meta: {
          title: 'Criação Coupons',
        },
        component: require('../../components/coupon/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CouponEdit',
        path: '/coupon/edit/:id',
        meta: {
          title: 'Edição Coupons',
        },
        component: require('../../components/coupon/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },

      {
        name: 'Contracts',
        path: '/contracts',
        meta: {
          title: 'Contratos',
        },
        component: require('../../components/contract/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'ContractCreate',
        path: '/contract/new',
        meta: {
          title: 'Criação Contratos',
        },
        component: require('../../components/contract/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'ContractEdit',
        path: '/contract/edit/:id',
        meta: {
          title: 'Edição Contratos',
        },
        component: require('../../components/contract/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Cooperatives',
        path: '/cooperatives',
        meta: {
          title: 'Cooperativas',
        },
        component: require('../../components/cooperative/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CooperativeCreate',
        path: '/cooperative/new',
        meta: {
          title: 'Criação Cooperativas',
        },
        component: require('../../components/cooperative/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CooperativeEdit',
        path: '/cooperative/edit/:id',
        meta: {
          title: 'Edição Cooperativas',
        },
        component: require('../../components/cooperative/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Investments',
        path: '/investments',
        meta: {
          title: 'Investimentos',
        },
        component: require('../../components/investment/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InvestimentCreate',
        path: '/investment/new',
        meta: {
          title: 'Criação Investimentos',
        },
        component: require('../../components/investment/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InvestimentEdit',
        path: '/investment/edit/:id',
        meta: {
          title: 'Edição Investimentos',
        },
        component: require('../../components/investment/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'InvestimentInvestors',
        path: '/investment-investors/:id',
        meta: {
          title: 'Investimentos E Investidores',
        },
        component: require('../../components/investiment-investors/index.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Commissions',
        path: '/commission',
        meta: {
          title: 'Comissões',
        },
        component: require('../../pages/commission/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'LeadsExtract',
        path: 'leads-extract',
        meta: {
          title: 'Leads:extrair',
        },
        component: require('../../pages/leads-extract/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Leads',
        path: 'leads',
        meta: {
          title: 'Leads',
        },
        component: require('../../pages/leads/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'LeadsQualified',
        path: 'qualified-leads',
        meta: {
          title: 'Leads qualificados',
        },
        component: require('../../pages/qualified-leads/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'LeadsReport',
        path: 'leads-report',
        meta: {
          title: 'Relatório de leads',
        },
        component: require('../../pages/leads-report/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CooperativeMembersDetails',
        path: '/cooperative-members/:id',
        meta: {
          title: 'Membros Cooperativa',
        },
        component: require('../../components/cooperative-members/index.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CooperativeMembersCreate',
        path: '/cooperative-members/new/:id',
        meta: {
          title: 'Criação Membros Cooperativa',
        },
        component: require('../../components/cooperative-members/edit.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CooperativeMembersEdit',
        path: '/cooperative-members/edit/:idCoop/:id',
        meta: {
          title: 'Edição Membros Cooperativa',
        },
        component: require('../../components/cooperative-members/edit.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CouponOwnersDetails',
        path: '/coupon-owners/:id',
        meta: {
          title: 'Membros Cooperativa',
        },
        component: require('../../components/coupon-owners/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CouponOwnersCreate',
        path: '/coupon-owners/new/:id',
        meta: {
          title: 'Criação Coupons',
        },
        component: require('../../components/coupon-owners/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CouponOwnersEdit',
        path: '/coupon-owners/edit/:id',
        meta: {
          title: 'Edição Coupons',
        },
        component: require('../../components/coupon-owners/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Notifications',
        path: '/notifications',
        meta: {
          title: 'Notificações',
        },
        component: require('../../components/notification/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Distributors',
        path: '/distributors',
        meta: {
          title: 'Distribuidores',
        },
        component: require('../../components/distributor/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'DistributorCreate',
        path: '/distributor/new',
        meta: {
          title: 'Criação Distribuidores',
        },
        component: require('../../components/distributor/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'DistributorEdit',
        path: '/distributor/edit/:id',
        meta: {
          title: 'Edição Distribuidores',
        },
        component: require('../../components/distributor/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Covenant',
        path: '/covenant',
        meta: {
          title: 'Convênios',
        },
        component: require('../../components/covenant/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CovenantCreate',
        path: '/covenant/new',
        meta: {
          title: 'Criação Convênios',
        },
        component: require('../../components/covenant/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'CovenantEdit',
        path: '/covenant/edit/:id',
        meta: {
          title: 'Edição Convênios',
        },
        component: require('../../components/covenant/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlants',
        path: '/power-plants',
        meta: {
          title: 'Usinas',
        },
        component: require('../../components/power-plant/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlantsCreate',
        path: '/power-plant/new',
        meta: {
          title: 'Criação Usinas',
        },
        component: require('../../components/power-plant/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlantsEdit',
        path: '/power-plant/edit/:id',
        meta: {
          title: 'Edição Usinas',
        },
        component: require('../../components/power-plant/edit.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlantDetails',
        path: '/power-plant/:id/data',
        meta: {
          title: 'Detalhes Usinas',
        },
        component: require('../../components/power-plant-data/index.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlantDataCreate',
        path: '/power-plant/:id/data/new',
        meta: {
          title: 'Criação Usinas',
        },
        component: require('../../components/power-plant-data/edit.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'PowerPlantDataEdit',
        path: '/power-plant/:id/data/edit/:idData',
        meta: {
          title: 'Edição Usinas',
        },
        component: require('../../components/power-plant-data/edit.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserSalesComissions',
        path: 'user/:id/sales-comissions/:accountId',
        meta: {
          title: 'Comissões',
        },
        component: require('../../components/sales-comissions/index.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserBonuses',
        path: 'user/:id/bonuses/:accountId',
        meta: {
          title: 'Bonus',
        },
        component: require('../../components/users/partner.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserSalesComissionsReport',
        path: 'user/:id/sales-comissions-report/:accountId',
        meta: {
          title: 'Report de Comissão',
        },
        component: require('../../components/sales-comissions/index-report.vue')
          .default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'UserInstallationDiscounts',
        path: 'user/:userId/installation/:id/discounts/:accountId',
        meta: {
          title: 'Descontos',
        },
        component: require('../../components/discounts/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'DefaultDiscounts',
        path: 'default-discounts',
        meta: {
          title: 'Descontos Base',
        },
        component: require('../../components/discounts/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
      {
        name: 'Calculation',
        path: 'calculation',
        meta: {
          title: 'Calculos',
        },
        component: require('../../components/calculations/index.vue').default,
        beforeEnter: hasPermissionToAccessBasedOnProfileGuard,
      },
    ],
  },
  { path: '/login', component: require('../../components/login.vue').default },
  {
    path: '/forgot',
    component: require('../../components/forgot.vue').default,
  },
  {
    path: '/admin/activate/:token',
    component: require('../../components/activate.vue').default,
  },
  {
    path: '/user/activate/:token',
    component: require('../../components/activate.vue').default,
  },
  {
    path: '/admin/change-password/:token',
    component: require('../../components/change-password.vue').default,
  },
  {
    path: '/user/change-password/:token',
    component: require('../../components/change-password.vue').default,
  },
  {
    path: '/user/recover-password/:token',
    component: require('../../components/recover-password.vue').default,
  },
  {
    path: '/apps/:token',
    component: require('../../components/apps.vue').default,
  },
  {
    path: '*',
    component: require('../../components/404.vue').default,
  },
  {
    path: '/not-found',
    component: require('../../components/404.vue').default,
  },
];
